import { Tag } from '@cian/components';
import * as React from 'react';

import { IIncludeNewMoscowTag } from '../../../state/tags/definitions/new_moscow';
import { TagNew } from '../TagNew';

import { tagThemeSmall } from '../tag_theme';

export interface INewMoscowTagItemProps {
  tag: IIncludeNewMoscowTag;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

export const NewMoscowTagItem = (props: INewMoscowTagItemProps) => {
  const TagComponent = React.useMemo(() => (props.withNewTag ? TagNew : Tag), [props.withNewTag]);

  return (
    <TagComponent onDeleteClick={props.onDeleteClick} tagStyles={tagThemeSmall}>
      {props.tag.value ? 'Новая Москва' : 'Без Новой Москвы'}
    </TagComponent>
  );
};
